<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
    <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <store-tenant-select domain="stock" @change="handleStoreTenantChange"></store-tenant-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择仓库"
                    allow-clear
                    style="width: 100%"
                    v-model="queryParam.depotId">
                    <a-select-option v-for="(item, index) in depotList" :key="index" :value="item.id">
                      {{ item.depotName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input
                    placeholder="条码/名称/助记码/规格/型号/多属性"
                    v-model="queryParam.materialParam"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button style="margin-left: 8px" icon="printer"
                    v-if="btnEnableList.indexOf('5')>-1" @click="handlePrint">打印</a-button>
                  <a-button style="margin-left: 8px" @click="exportExcel" icon="download"
                    v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                  <a @click="toggleSearchStatus = !toggleSearchStatus" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
            <template v-if="toggleSearchStatus">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-tree-select
                      style="width: 100%"
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      allow-clear
                      :treeData="categoryTree"
                      v-model="queryParam.categoryId"
                      placeholder="请选择类别">
                    </a-tree-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="品牌" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入品牌" v-model="queryParam.brand"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="制造商" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入制造商" v-model="queryParam.mfrs"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </a-form>
        </div>

        <!-- 汇总信息 -->
        <div style="margin-bottom: 8px; padding: 8px 12px; background: #fafafa; border: 1px solid #e8e8e8; border-radius: 4px;">
          <span style="font-weight: 500;">总库存：{{ summary.totalNum.toFixed(2) }}</span>
          <span style="font-weight: 500; margin-left: 24px;">总库存金额：{{ summary.totalPrice.toFixed(2) }}</span>
        </div>

        <section ref="print" id="reportPrint">
          <a-table
            bordered
            ref="table"
            size="middle"
            rowKey="key"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <span slot="actionCustomRender" slot-scope="text, record">
              <a @click="showFlowModal(record)">库存流水</a>
            </span>
          </a-table>
          <a-row :gutter="24" style="margin-top: 8px; textAlign: right">
            <a-col :md="24" :sm="24">
              <a-pagination
                @change="paginationChange"
                @showSizeChange="paginationShowSizeChange"
                size="small"
                show-size-changer
                show-quick-jumper
                :current="ipagination.current"
                :page-size="ipagination.pageSize"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total"
              />
            </a-col>
          </a-row>
        </section>
      </a-card>
    </a-col>
    </a-row>
    </template>

    <!-- 打印模式 -->
    <template v-if="printMode">
      <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="printDataSource"
        :queryParam="queryParam"
        billType="BATCH_STOCK"
        billTypeName="批次库存统计"
        :buildData="buildPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
        @back="printMode = false"
      />
    </template>

    <!-- 库存流水弹窗 -->
    <BatchStockFlowModal ref="flowModal" />
  </div>
</template>
<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { queryMaterialCategoryTreeList } from '@/api/api'
  import { getAction } from '@/api/manage'
  import moment from 'moment'
  import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
  import StoreTenantSelect from '@/components/StoreTenantSelect'
  import BatchStockFlowModal from './BatchStockFlowModal.vue'
  import { defColumns, buildPrintData } from './batchStockConfig'

  export default {
    name: "BatchStockList",
    mixins: [JeecgListMixin],
    components: {
      ReportPrint,
      StoreTenantSelect,
      BatchStockFlowModal
    },
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
        queryParam: {
          depotId: undefined,
          materialParam: '',
          categoryId: undefined,
          brand: '',
          mfrs: ''
        },
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          total: 0
        },
        summary: {
          totalNum: 0,
          totalPrice: 0
        },
        depotList: [],
        categoryTree: [],
        columns: [],
        defColumns: defColumns,
        url: {
          list: '/api/plugin/batch-stock/batchStock/getList',
          total: '/api/plugin/batch-stock/batchStock/totalCountMoney'
        },
        urlPath: '/plugin/batch-stock',
        printDataSource: [],
        printMode: false,
        printTitle: '批次库存统计-打印预览',
        isorter: {
          column: 'me.id',
          order: 'desc'
        }
      }
    },
    created() {
      this.columns = this.defColumns
      this.getDepotData()
      this.loadCategoryTreeData()
    },
    methods: {
      moment,
      buildPrintData,
      handleStoreTenantChange() {
        this.searchQuery()
      },
      getDepotData() {
        getAction('/depot/findDepotByCurrentUser').then((res) => {
          if (res && res.code === 200 && res.data) {
            this.depotList = res.data
          }
        }).catch((err) => { console.error('获取仓库失败', err) })
      },
      loadCategoryTreeData() {
        queryMaterialCategoryTreeList({ id: '' }).then((res) => {
          if (res) {
            this.categoryTree = []
            for (let i = 0; i < res.length; i++) {
              this.categoryTree.push(res[i])
            }
          }
        }).catch((err) => { console.error('获取类别失败', err) })
      },
      loadTotalCount() {
        const params = {
          materialParam: this.queryParam.materialParam || undefined,
          depotId: this.queryParam.depotId || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          brand: this.queryParam.brand || undefined,
          mfrs: this.queryParam.mfrs || undefined
        }
        getAction(this.url.total, params).then((res) => {
          if (res && res.code === 200 && res.data) {
            this.summary.totalNum = res.data.totalNum || 0
            this.summary.totalPrice = res.data.totalPrice || 0
          }
        }).catch((err) => { console.error('获取汇总失败', err) })
      },
      loadData() {
        if (!this.url.list) {
          this.$message.error("请设置url.list属性!")
          return
        }
        const params = {
          materialParam: this.queryParam.materialParam || undefined,
          depotId: this.queryParam.depotId || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          brand: this.queryParam.brand || undefined,
          mfrs: this.queryParam.mfrs || undefined,
          column: this.isorter.column || 'me.id',
          order: this.isorter.order || 'desc',
          currentPage: this.ipagination.current,
          pageSize: this.ipagination.pageSize
        }
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res && res.code === 200 && res.data) {
            const rows = res.data.rows || []
            rows.forEach((row, i) => {
              row.rowIndex = (this.ipagination.current - 1) * this.ipagination.pageSize + i + 1
              row.key = (row.batchNumber || '') + '_' + (row.depotId || 0) + '_' + (row.materialId || 0)
            })
            this.dataSource = rows
            this.ipagination.total = res.data.total || 0
            this.tableAddTotalRow(this.columns, this.dataSource)
          } else if (res && res.code === 510) {
            this.$message.warning(res.data)
          } else {
            this.dataSource = []
            this.ipagination.total = 0
          }
          this.loading = false
        }).catch((err) => {
          this.loading = false
          this.$message.error('查询失败: ' + (err.message || '未知错误'))
          console.error(err)
        })
        this.loadTotalCount()
      },
      showFlowModal(record) {
        this.$refs.flowModal.show(record)
      },
      tableAddTotalRow(columns, dataSource) {
        if (dataSource.length > 0) {
          let numKey = 'rowIndex'
          let totalRow = { [numKey]: '合计' }
          let parseCols = 'totalNum,totalPrice,'
          columns.forEach(column => {
            let { key, dataIndex } = column
            if (![key, dataIndex].includes(numKey)) {
              let total = 0
              let hasSum = false
              dataSource.forEach(data => {
                if (parseCols.indexOf(dataIndex + ',') > -1) {
                  hasSum = true
                  if (data[dataIndex]) {
                    total += Number.parseFloat(data[dataIndex])
                  }
                }
              })
              if (hasSum) {
                totalRow[dataIndex] = parseFloat(total.toFixed(2))
              }
            }
          })
          dataSource.push(totalRow)
        }
      },
      handleTableChange(pagination, filters, sorter) {
        if (sorter && sorter.column) {
          this.isorter.column = sorter.field || sorter.columnKey || 'me.id'
          this.isorter.order = sorter.order || 'desc'
        }
        if (pagination) {
          this.ipagination.current = pagination.current
          this.ipagination.pageSize = pagination.pageSize
        }
        this.loadData()
      },
      searchReset() {
        this.queryParam = {
          depotId: undefined,
          materialParam: '',
          categoryId: undefined,
          brand: '',
          mfrs: ''
        }
        this.ipagination.current = 1
        this.loadData()
      },
      async fetchAllData() {
        const pageSize = 500
        let allRows = []
        let total = 0
        const baseParams = {
          materialParam: this.queryParam.materialParam || undefined,
          depotId: this.queryParam.depotId || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          brand: this.queryParam.brand || undefined,
          mfrs: this.queryParam.mfrs || undefined,
          column: this.isorter.column || 'me.id',
          order: this.isorter.order || 'desc',
          pageSize: pageSize
        }
        const firstParams = { ...baseParams, currentPage: 1 }
        const firstRes = await getAction(this.url.list, firstParams)
        if (firstRes && firstRes.code === 200 && firstRes.data) {
          total = firstRes.data.total || 0
          allRows = allRows.concat(firstRes.data.rows || [])
        }
        const totalPages = Math.ceil(total / pageSize)
        for (let page = 2; page <= totalPages; page++) {
          const params = { ...baseParams, currentPage: page }
          const res = await getAction(this.url.list, params)
          if (res && res.code === 200 && res.data) {
            allRows = allRows.concat(res.data.rows || [])
          }
        }
        allRows.forEach((row, i) => { 
          row.rowIndex = i + 1
          row.key = (row.batchNumber || '') + '_' + (row.depotId || 0) + '_' + (row.materialId || 0)
        })
        this.addTotalRow(allRows)
        return allRows
      },
      addTotalRow(dataSource) {
        if (dataSource.length === 0) return
        const totalRow = { rowIndex: '合计' }
        let totalNum = 0
        let totalPrice = 0
        dataSource.forEach(row => {
          if (row.totalNum) {
            totalNum += Number.parseFloat(row.totalNum)
          }
          if (row.totalPrice) {
            totalPrice += Number.parseFloat(row.totalPrice)
          }
        })
        totalRow.totalNum = parseFloat(totalNum.toFixed(2))
        totalRow.totalPrice = parseFloat(totalPrice.toFixed(2))
        dataSource.push(totalRow)
      },
      async handlePrint() {
        this.loading = true
        try {
          const allRows = await this.fetchAllData()
          if (!allRows || allRows.length === 0) {
            this.$message.warning('暂无数据可打印')
            return
          }
          this.printDataSource = allRows
          this.printTitle = '批次库存统计-打印预览'
          this.printMode = true
        } catch (err) {
          this.$message.error('获取打印数据失败: ' + (err.message || '未知错误'))
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      onDesignerChange(visible) {
        this.printTitle = visible ? '批次库存统计-报表设计' : '批次库存统计-打印预览'
      },
      exportExcel() {
        const list = []
        const head = '条码,名称,规格,型号,类别,单位,批号,有效日期,扩展信息,成本价,批次库存,库存金额'
        const exportData = this.dataSource.filter(item => item.rowIndex !== '合计')
        for (let i = 0; i < exportData.length; i++) {
          const ds = exportData[i]
          list.push([
            ds.materialCode || '', ds.materialName || '', ds.materialStandard || '',
            ds.materialModel || '', ds.categoryName || '', ds.materialUnit || '',
            ds.batchNumber || '', ds.expirationDateStr || '', ds.expand || '',
            ds.purchaseDecimal || 0, ds.totalNum || 0, ds.totalPrice || 0
          ])
        }
        let tip = '查询条件'
        if (this.queryParam.depotId) tip += ', 仓库ID=' + this.queryParam.depotId
        if (this.queryParam.materialParam) tip += ', 商品=' + this.queryParam.materialParam
        let totalItem = ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', 0, 0]
        for (let i = 0; i < exportData.length; i++) {
          const ds = exportData[i]
          totalItem[10] += Number.parseFloat(ds.totalNum || 0)
          totalItem[11] += Number.parseFloat(ds.totalPrice || 0)
        }
        totalItem[10] = totalItem[10].toFixed(2)
        totalItem[11] = totalItem[11].toFixed(2)
        list.push(totalItem)
        this.handleExportXlsPost('批次库存统计', '批次库存统计', head, tip, list)
      }
    }
  }
</script>